const HowItWorks = () => (
  <section className="py-20 bg-[#1E2328]" data-testid="how-it-works">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">How FlyFinder Matches Flies to Active Hatches</h2>
        <p className="text-lg text-slate-400 max-w-2xl mx-auto">Quick overview: from conditions to recommendation</p>
      </div>

      <div className="grid md:grid-cols-4 gap-6 max-w-5xl mx-auto">
        {[
          { step: 1, title: 'Your Location', desc: 'Regional hatch database + watershed context' },
          { step: 2, title: 'Real-Time Data', desc: 'Water temp, weather, season, time of day' },
          { step: 3, title: 'Hatch Matching', desc: 'Cross-reference active species + emergence triggers' },
          { step: 4, title: 'Your Recommendation', desc: 'Fly pattern, size, color, presentation tip' },
        ].map((item) => (
          <div key={item.step} className="text-center">
            <div className="relative inline-block mb-4">
              <div className="w-16 h-16 bg-[#137dc5] text-white rounded-full flex items-center justify-center text-2xl font-bold shadow-lg">
                {item.step}
              </div>
            </div>
            <h3 className="text-lg font-bold text-white mb-2">{item.title}</h3>
            <p className="text-sm text-slate-400">{item.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-12 text-center">
        <p className="text-slate-400 max-w-2xl mx-auto">
          Simple interface, complex intelligence underneath. That's how it should be.
        </p>
      </div>
    </div>
  </section>
);

export default HowItWorks;
